enum ErrorActions {
  ERROR = 'ERROR',
  STORE_ACCESS_ERROR = 'STORE_ACCESS_ERROR',
  REQUEST_ERROR = 'REQUEST_ERROR'
}
export default ErrorActions
